module.exports = __webpack_public_path__ + "img/swine-project.726a4353.png";